export default __webpack_public_path__ + "static/media/silver_promise.0ae2eddb.svg";